export default "__VITE_ASSET___gVIdhPX__"